import React, { useState } from 'react';
import '../styles/AuditTypeModal.css';
import thermaxLogo from "../assets/Thermax-Logo.wine01.png";

function AuditTypeModal({ onSelect }) {
  const options = [
    { value: 'Internal', label: 'Internal Audit' },
    { value: 'External', label: 'External Audit' }
  ];
  const [selectedAuditType, setSelectedAuditType] = useState('Internal');

  return (
    <div className="audit-type-overlay">
      <div className="audit-type-modal">
        <img src={thermaxLogo} alt="Thermax" className="audit-type-logo" />
        <h2>Select Audit Type</h2>
        <p>Choose the section you want to work in for this financial scope.</p>

        <div className="audit-type-options">
          {options.map((option) => (
            <label key={option.value} className={`audit-type-option ${selectedAuditType === option.value ? 'active' : ''}`}>
              <input
                type="radio"
                name="auditType"
                value={option.value}
                checked={selectedAuditType === option.value}
                onChange={() => setSelectedAuditType(option.value)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>

        <button className="audit-type-confirm-btn" onClick={() => onSelect(selectedAuditType)}>
          Continue
        </button>
      </div>
    </div>
  );
}

export default AuditTypeModal;
